import React, { useEffect } from 'react';
import useProfile from '../../hooks/useProfile';
import {
  revokeToken,
  setUserId,
  setMobileNumber
} from '../../utils/session-utils';

const ClearCache = ({ history }) => {
  const { clearProfile } = useProfile();

  useEffect(() => {
    clearProfile();
    revokeToken();
    setUserId(null);
    setMobileNumber(null);
    history.push('/');
  });

  return <div />;
};

export default ClearCache;
